// Shared access rules for launchers and pages (spec §3.4): access = holds the code AND meets minAccess.
const RANK = { User: 0, Sales: 1, Admin: 2, 'Super Admin': 3 };

export function rankOf(minAccess) {
    return RANK[minAccess] ?? 0;
}

export function userRank(user) {
    if (!user) return -1;
    if (user.isSuperAdmin) return RANK['Super Admin'];
    if (user.role === 'admin') return RANK.Admin;
    if (user.role === 'sales') return RANK.Sales;
    return RANK.User;
}

export function hasCode(user, code) {
    if (!user) return false;
    if (user.isSuperAdmin || user.authorizedForAll) return true;
    return Array.isArray(user.allowedFunctions) && user.allowedFunctions.includes(code);
}

/**
 * A definition is usable when the user meets its minAccess AND holds its code — or holds any
 * capability code that shares its route (e.g. GA_* unlock the /global-action-center page).
 */
export function canUseDefinition(user, def, allDefs = []) {
    if (!user || !def) return false;
    if (userRank(user) < rankOf(def.minAccess)) return false;
    if (hasCode(user, def.code)) return true;
    return allDefs.some((d) => d.route === def.route && d.code !== def.code && d.enabled !== false && hasCode(user, d.code) && userRank(user) >= rankOf(d.minAccess));
}

const toItem = (d) => ({ code: d.code, path: d.route, label: d.name });
const byLabel = (a, b) => a.label.localeCompare(b.label);

/** Launcher contents for the internal surface: enabled, launcher-visible, not portal-only, not Admin category. */
export function launcherGroups(user, defs = []) {
    const visible = defs.filter((d) =>
        d.enabled !== false && d.launcher !== false && d.scope !== 'portal' && d.category !== 'Admin' && canUseDefinition(user, d, defs)
    );
    return {
        saas: visible.filter((d) => d.category === 'SaaS').map(toItem).sort(byLabel),
        tool: visible.filter((d) => d.category === 'On-Prem').map(toItem).sort(byLabel),
    };
}
